let form = $('.c-search');
let btn = $('.c-search__button');
let input;

export function init() {
	btn.on('click', checkLenght);
}

let checkLenght = function(event){
	event.preventDefault();
	form.removeClass('input__error');
	input= $("input[name=search]").val();

	if( input.length >= 3 ){
		form.submit();
	}else{
		form.addClass('input__error');
	}
}


// WEBPACK FOOTER //
// ./src/js/modules/search.js